import { defineDocStore } from './base/baseDocStore'
import type { EmailSubscription } from '@/types/email'
import { EmailSubscriptionFactory } from '@/factories/emailSubscriptionFactory'

export const useEmailSubscriptionStore = defineDocStore<EmailSubscription>({
  entityName: 'emailSubscription',
  collection: 'email_subscriptions',
  model: {
    create: EmailSubscriptionFactory.create,
    normalize: undefined,
  },
  initialState: {
    filters: {
      global: { value: null, matchMode: 'contains' },
      listId: { value: null, matchMode: 'equals' },
      status: { value: null, matchMode: 'equals' },
    },
    sort: { field: 'subscribedAt', order: -1 },
  },
})
